import { CobrowsingDispatcher } from '@agent/core/store/cobrowsing/cobrowsing.dispatcher';
import { CobrowsingInfo } from '@agent/core/store/cobrowsing/cobrowsing.model';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { getCobrowsingSessionById } from '../agent.store';

@Injectable({
  providedIn: 'root',
})
export class CobrowsingFacade {
  getByBookingId(sessionId: string): Observable<CobrowsingInfo | undefined> {
    return this.store$.pipe(select(getCobrowsingSessionById(sessionId)));
  }

  startCobrowsing(info: CobrowsingInfo) {
    return this.store$.dispatch(this.cobrowsingDispatcher.startCobrowsing(info));
  }

  updateCobrowsingState(info: CobrowsingInfo) {
    return this.store$.dispatch(this.cobrowsingDispatcher.cobrowsingSessionUpdated(info));
  }

  endCobrowsing(bookingId: string) {
    return this.store$.dispatch(this.cobrowsingDispatcher.endCobrowsing(bookingId));
  }

  cobrowsingEnded(bookingId: string) {
    return this.store$.dispatch(this.cobrowsingDispatcher.cobrowsingEnded(bookingId));
  }

  removeCobrowsing(bookingId: string) {
    return this.store$.dispatch(this.cobrowsingDispatcher.removeCobrowsing(bookingId));
  }

  constructor(private readonly store$: Store, private readonly cobrowsingDispatcher: CobrowsingDispatcher) {}
}
